module.exports = __webpack_public_path__ + "static/img/best-quantity.50936897.png";